export {
  SkyListPagingComponent
} from './list-paging.component';
export {
  SkyListPagingModule
} from './list-paging.module';
